module.exports = __webpack_public_path__ + "static/media/st-1.0cf5dfbd.jpg";